import { render, staticRenderFns } from "./commonActivity.vue?vue&type=template&id=5131118f&"
import script from "./commonActivity.vue?vue&type=script&lang=js&"
export * from "./commonActivity.vue?vue&type=script&lang=js&"
import style0 from "./commonActivity.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports